import { Injectable } from '@angular/core';
import { AuthInterceptor } from 'src/app/interceptors/auth.interceptor';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor() {}

  public isLoggedIn(): boolean {
    return (
      localStorage.getItem('token') != null &&
      localStorage.getItem('userId') != null
    );
  }

  public canAudit(): boolean {
    let companySelected = localStorage.getItem('lastCompanySelected');
    return (
      companySelected === 'Q29tcGFueToyMA==' ||
      companySelected === 'Q29tcGFueTo5MQ=='
    );
  }

  /** Lógica para validar o status de pagamento (adimplente/inadimplente) **/
  public getPaymentStatus(): boolean {
    return true;
  }
}
